import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const Cursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [label, setLabel] = useState("");
  const [hover, setHover] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 400, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 400, damping: 40, mass: 0.4 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("has-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const t = e.target.closest("[data-cursor]");
      const interactive = e.target.closest("a, button, [role=button], input, textarea, select, label");
      setLabel(t?.dataset.cursor || "");
      setHover(!!interactive || !!t);
    };
    window.addEventListener("mousemove", move);
    return () => {
      window.removeEventListener("mousemove", move);
      document.body.classList.remove("has-cursor");
    };
  }, [x, y]);

  if (!enabled) return null;
  const size = label ? 88 : hover ? 44 : 12;
  return (
    <motion.div
      aria-hidden
      className="fixed left-0 top-0 z-[100] pointer-events-none flex items-center justify-center rounded-full"
      style={{ x: sx, y: sy, translateX: "-50%", translateY: "-50%" }}
    >
      <motion.div
        animate={{ width: size, height: size, backgroundColor: label ? "#FBF9F5" : "#1C1B1A", opacity: hover && !label ? 0.35 : 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="rounded-full flex items-center justify-center"
        style={{ mixBlendMode: label ? "normal" : "normal" }}
      >
        {label && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal">{label}</span>}
      </motion.div>
    </motion.div>
  );
};
